/** Bound permission reads even when an adapter cannot accept an AbortSignal. */
export async function withPermissionRequestTimeout<T>(
  request: Promise<T>,
  timeoutMs = 15_000
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      request,
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () => reject(new Error('Permission request timed out')),
          timeoutMs
        );
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
